export default "__VITE_ASSET__7daA8do5__"